var TransactionAction;
(function (TransactionAction) {
    TransactionAction[TransactionAction["DEPOSIT_EDIT_REG"] = 101] = "DEPOSIT_EDIT_REG";
    TransactionAction[TransactionAction["DEPOSIT_EDIT_DEPOSIT"] = 102] = "DEPOSIT_EDIT_DEPOSIT";
    TransactionAction[TransactionAction["DEPOSIT_CANCEL_DEPOSIT"] = 103] = "DEPOSIT_CANCEL_DEPOSIT";
    TransactionAction[TransactionAction["DEPOSIT_PAYMENT"] = 104] = "DEPOSIT_PAYMENT";
    TransactionAction[TransactionAction["DEPOSIT_PAYMENT_VOID"] = 105] = "DEPOSIT_PAYMENT_VOID";
})(TransactionAction || (TransactionAction = {}));
export default TransactionAction;
